
import { Link } from 'react-router-dom';
import { useI18n } from 'src/utils/lni18n';
import LnIcon from 'src/components/LnIcon';
import {  PublishPartViewDataDTO } from '../domain/PublishPartViewDataDTO';

export default function UsedBy(props: { publishData: PublishPartViewDataDTO }) {

    const { languageService: t } = useI18n();
    const publishData = props.publishData;

    if (!publishData ) return null;

    return <>


        {publishData.Classes && publishData.Classes.length > 0 &&
            <div className='mb-5'>
                <hr />
                <div className='d-flex'>
                    <div className='flex-fill'>
                        <h3 className='mb-3'>{t.getText("used.by")}</h3>
                        {publishData.Classes.map(c =>
                            <div key={c.Id} className="mb-3">
                                <strong>{c.Name}</strong>
                                <div>{t.getShortDateString(c.StartDate)}&nbsp;&nbsp;&#8594;&nbsp;&nbsp;{t.getShortDateString(c.ClassEndDate)}</div>
                                <div>
                                    {t.getText("course")}:&nbsp;
                                    <Link to={`/course/${c.Course.Id}/general`}>{c.Course.Name}</Link>

                                </div>
                            </div>
                        )
                        }
                    </div>
                    <div className='ml-3 '>
                        <div className='alert alert-danger'>
                            {t.getText("publish.warning")}
                            <LnIcon name="alert" className='icon-small ml-2 mb-2' />
                        </div>


                    </div>
                </div>

            </div>}

        {publishData.OtherCourses && publishData.OtherCourses.length > 0 && <div>
            <hr />
            <h3 className='mb-3'>{t.getText("part.of.following.courses")}</h3>
            {publishData.OtherCourses.map(c => <div key={c.Id} className='mb-3'>
                <Link to={`/course/${c.Id}/general`}>{c.Name}</Link>
            </div>)}
        </div>}

    </>



}